<template>
  <!--个人主页-->
  <div>
    <div class="userWrapper1">
   <div class="userWrapper">
     <div class="userPicWrpper">
       <img :src="userScoreInfo.avatarUrl!=null&&userScoreInfo.avatarUrl!=''?userScoreInfo.avatarUrl:gobalUrl + 'images/basicprofile.png'" class="userPic"   />
     </div>
     <div class="userDelWrpper">
       <div class="userName">{{userScoreInfo.nikeName!=null&&userScoreInfo.nikeName!=''?userScoreInfo.nikeName:'券粉'}}</div>
       <div class="userSex">{{userScoreInfo.gender==1?'男':userScoreInfo.gender==0?'女':''}} LV{{userScoreInfo.degreeID}}</div>
       <div class="userDes">Ta 晒单 {{userScoreInfo.paperCount}} 次 兑换礼品 3 次</div>
     </div>
   </div>
 </div>
   <userPaper  :openID='openid'></userPaper>
 </div>
</template>
<script type = "text/ecamscript-6">
  import {config} from  '../../common/js/common.js'//导入全局配置基础网址
  import UserPaper from '@/components/quan/userPaper'
  export default {
    'name':'user',
    data(){
      return{
        openid:this.$route.params.openid,//获取id
        userScoreInfo:[],
        gobalUrl : config.gobalUrl,
      }
    },
    created () {
      this.login()
    },
    methods:{
      /*axios调用主页头部*/
       login () {
         this.url = "api/getUserAllInfo.php?openID="+this.openid
         console.log(this.url )
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.userScoreInfo= this.userScoreInfo.concat(res.data.map(function(item){
                 return item
               }))
               this.userScoreInfo = this.userScoreInfo[0]
              console.log(this.userScoreInfo)
             }, (res) => {
                 console.log("error")
             })
        },
    },
    components:{
      'userPaper':UserPaper
    }
  }
</script>

<style lang="stylus">
  .userWrapper1
    width: 100%
    height: 224px
    position: relative
    background:url(../../images/quan_bg.jpg)no-repeat left top
    background-size:100%
    .userWrapper
      position: relative
      z-index: 1
      padding:40px 30px 0
      display: flex
      .userPicWrpper
        flex: 0 0 150px
        margin-right: 25px
        .userPic
          width: 150px
          height: 150px
          border: 4px solid #fff
          box-sizing: border-box
          border-radius: 50%
      .userDelWrpper
        flex: 1
        padding-top: 10px
        color: #fff
        .userName
          font-size: 34px
        .userSex
          width: 112px
          height: 30px
          background: #ffb400
          border-radius: 15px
          font-size: 20px
          color: #fff
          line-height: 30px
          text-align: center
          margin-top: 10px
          box-sizing: border-box
        .userDes
          font-size: 24px
          color: #e5e5e5
          margin-top: 10px


</style>



// WEBPACK FOOTER //
// src/components/quan/user.vue